export function AccessYourTradingPlatformIcon() {
  return (
    <svg
      width='338'
      height='235'
      viewBox='0 0 338 235'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33.6012 76.623H232.635C238.404 76.623 243.091 81.3051 243.091 87.0797V223.186H23.1445V87.0797C23.1445 81.3051 27.8322 76.623 33.6012 76.623Z'
        fill='#D9D9D9'
        stroke='#3C3C3C'
        strokeWidth='0.810534'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.27734 224.641C1.27734 223.837 1.92841 223.186 2.73799 223.186H263.504C264.308 223.186 264.964 223.837 264.964 224.647V225.207C264.964 229.946 261.12 233.79 256.382 233.79H9.85442C5.1158 233.79 1.27734 229.946 1.27734 225.207V224.647V224.641Z'
        fill='#D9D9D9'
        stroke='#3C3C3C'
        strokeWidth='0.810534'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g clipPath='url(#clip0_19183_198407)'>
        <rect x='26.7383' y='80.73' width='211.77' height='138.06' rx='7.02' fill='white' />
        <mask
          id='mask0_19183_198407'
          maskUnits='userSpaceOnUse'
          x='50'
          y='107'
          width='29'
          height='29'
        >
          <path
            d='M68.4269 107.64H59.9266C57.1076 107.64 55.6982 107.64 54.1809 108.12C52.5242 108.723 51.2194 110.028 50.6164 111.684C50.1367 113.202 50.1367 114.611 50.1367 117.43V125.93C50.1367 128.749 50.1367 130.158 50.6164 131.676C51.2194 133.333 52.5242 134.637 54.1809 135.24C55.6982 135.72 57.1076 135.72 59.9266 135.72H68.4269C71.2459 135.72 72.655 135.72 74.1725 135.24C75.8292 134.637 77.134 133.333 77.737 131.676C78.2167 130.158 78.2167 128.749 78.2167 125.93V117.43C78.2167 114.611 78.2167 113.202 77.737 111.684C77.134 110.028 75.8292 108.723 74.1725 108.12C72.655 107.64 71.2459 107.64 68.4269 107.64Z'
            fill='#C4C4C4'
          />
        </mask>
        <g mask='url(#mask0_19183_198407)'>
          <rect width='28.08' height='28.08' transform='translate(50.1367 107.64)' fill='#490619' />
          <path
            d='M65.4034 126.365H62.106C61.7085 126.365 61.3343 126.154 61.1356 125.804L59.2413 122.518C59.0425 122.167 59.0425 121.746 59.2413 121.395L61.1356 118.11C61.3343 117.759 61.7085 117.548 62.106 117.548H65.4034L68.0226 113C67.9641 113 67.9057 113 67.8589 113H60.1416C59.3232 113 58.5748 113.433 58.1656 114.146L54.3069 120.811C53.8977 121.512 53.8977 122.389 54.3069 123.091L58.1656 129.779C58.5748 130.481 59.3232 130.925 60.1416 130.925H67.8589C67.9173 130.925 67.9758 130.925 68.0342 130.925L65.4151 126.377L65.4034 126.365Z'
            fill='#FF0044'
          />
          <path
            d='M73.6924 120.811L69.8338 114.123C69.8104 114.076 69.7753 114.029 69.7403 113.982L67.1211 118.531L68.7697 121.396C68.9686 121.746 68.9686 122.167 68.7697 122.518L67.1211 125.383L69.7403 129.931C69.7753 129.885 69.8104 129.838 69.8338 129.791L73.6924 123.103C74.1017 122.401 74.1017 121.524 73.6924 120.823V120.811Z'
            fill='#28F981'
          />
        </g>
        <path
          d='M103.871 154.071H51.4076C50.7159 154.071 50.1562 154.817 50.1562 155.739C50.1562 156.662 50.7159 157.408 51.4076 157.408H103.874C104.566 157.408 105.126 156.662 105.126 155.739C105.126 154.817 104.566 154.071 103.874 154.071H103.871Z'
          fill='#EBEBEB'
        />
        <path
          d='M92.2366 161.124H51.4076C50.7159 161.124 50.1562 161.87 50.1562 162.793C50.1562 163.715 50.7159 164.461 51.4076 164.461H92.2366C92.9283 164.461 93.488 163.715 93.488 162.793C93.488 161.87 92.9283 161.124 92.2366 161.124Z'
          fill='#EBEBEB'
        />
        <path
          d='M70.8836 168.304H51.4076C50.7159 168.304 50.1562 169.05 50.1562 169.972C50.1562 170.895 50.7159 171.641 51.4076 171.641H70.8836C71.5753 171.641 72.1349 170.895 72.1349 169.972C72.1349 169.05 71.5753 168.304 70.8836 168.304Z'
          fill='#EBEBEB'
        />
        <rect
          x='50.1367'
          y='147.419'
          width='27.2974'
          height='3.33342'
          rx='1.66671'
          fill='#EBEBEB'
        />
        <g clipPath='url(#clip1_19183_198407)'>
          <rect
            width='1.61434'
            height='13.4105'
            rx='0.807172'
            transform='matrix(-1 0 0 1 224.438 128.41)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='2.98012'
            rx='1.49006'
            transform='matrix(-1 0 0 1 226.055 128.41)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='37.2515'
            rx='0.807172'
            transform='matrix(-1 0 0 1 218.059 106.43)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='11.1754'
            rx='2.42152'
            transform='matrix(-1 0 0 1 219.676 132.133)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='13.4105'
            rx='0.807172'
            transform='matrix(-1 0 0 1 211.691 131.015)'
            fill='#C6C6C7'
          />
          <rect
            width='4.84304'
            height='3.72515'
            rx='1.86257'
            transform='matrix(-1 0 0 1 213.305 139.211)'
            fill='#C6C6C7'
          />
          <rect
            width='1.61434'
            height='19.7433'
            rx='0.807172'
            transform='matrix(-1 0 0 1 205.309 122.077)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='4.09766'
            rx='2.04883'
            transform='matrix(-1 0 0 1 206.93 135.113)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='17.5082'
            rx='0.807172'
            transform='matrix(-1 0 0 1 198.949 131.015)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='3.35263'
            rx='1.67632'
            transform='matrix(-1 0 0 1 200.559 141.817)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='8.94035'
            rx='0.807172'
            transform='matrix(-1 0 0 1 192.574 137.347)'
            fill='#C6C6C7'
          />
          <rect
            width='4.84304'
            height='2.98012'
            rx='1.49006'
            transform='matrix(-1 0 0 1 194.184 143.308)'
            fill='#C6C6C7'
          />
          <rect
            width='1.61434'
            height='15.6456'
            rx='0.807172'
            transform='matrix(-1 0 0 1 186.199 138.838)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='4.84269'
            rx='2.42135'
            transform='matrix(-1 0 0 1 187.812 144.052)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='22.3509'
            rx='0.807172'
            transform='matrix(-1 0 0 1 179.832 140.7)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='11.548'
            rx='2.42152'
            transform='matrix(-1 0 0 1 181.441 149.644)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='16.3906'
            rx='0.807172'
            transform='matrix(-1 0 0 1 173.465 142.562)'
            fill='#C6C6C7'
          />
          <rect
            width='4.84304'
            height='9.68538'
            rx='2.42152'
            transform='matrix(-1 0 0 1 175.078 148.898)'
            fill='#C6C6C7'
          />
          <rect
            width='1.61434'
            height='20.4883'
            rx='0.807172'
            transform='matrix(-1 0 0 1 167.086 146.661)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='18.2532'
            rx='2.42152'
            transform='matrix(-1 0 0 1 168.695 148.898)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='19.7433'
            rx='0.807172'
            transform='matrix(-1 0 0 1 160.715 152.251)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='3.72515'
            rx='1.86257'
            transform='matrix(-1 0 0 1 162.32 166.779)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='32.4088'
            rx='0.807172'
            transform='matrix(-1 0 0 1 154.336 145.542)'
            fill='#C6C6C7'
          />
          <rect
            width='4.84304'
            height='23.0959'
            rx='2.42152'
            transform='matrix(-1 0 0 1 155.949 150.389)'
            fill='#C6C6C7'
          />
          <rect
            width='1.61434'
            height='10.4304'
            rx='0.807172'
            transform='matrix(-1 0 0 1 147.973 154.857)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='2.98012'
            rx='1.49006'
            transform='matrix(-1 0 0 1 149.586 157.838)'
            fill='#ECECEC'
          />
          <rect
            width='1.61434'
            height='18.2532'
            rx='0.807172'
            transform='matrix(-1 0 0 1 141.594 149.272)'
            fill='#C6C6C7'
          />
          <rect
            width='4.84304'
            height='14.5281'
            rx='2.42152'
            transform='matrix(-1 0 0 1 143.203 149.644)'
            fill='#C6C6C7'
          />
          <rect
            width='1.61434'
            height='29.8012'
            rx='0.807172'
            transform='matrix(-1 0 0 1 135.223 135.487)'
            fill='#ECECEC'
          />
          <rect
            width='4.84304'
            height='14.9006'
            rx='2.42152'
            transform='matrix(-1 0 0 1 136.832 149.644)'
            fill='#ECECEC'
          />
        </g>
        <path
          d='M69.8906 184.226H54.2397C51.9758 184.226 50.1406 186.057 50.1406 188.316C50.1406 190.575 51.9758 192.407 54.2397 192.407H69.8906C72.1544 192.407 73.9896 190.575 73.9896 188.316C73.9896 186.057 72.1544 184.226 69.8906 184.226Z'
          fill='#424244'
        />
      </g>
      <g filter='url(#filter0_dddd_19183_198407)'>
        <g clipPath='url(#clip2_19183_198407)'>
          <rect x='143.738' y='31.5898' width='150.93' height='98.3964' rx='4.68' fill='white' />
          <g clipPath='url(#clip3_19183_198407)'>
            <path
              d='M219.789 80.2438L222.782 77.0182C222.957 76.8289 223.264 76.8553 223.405 77.0719L226.432 81.732C226.455 81.7678 226.472 81.807 226.483 81.8483L229.38 93.0015C229.486 93.407 230.066 93.3932 230.152 92.9831L233.122 78.8092C233.136 78.7388 233.17 78.6736 233.219 78.6209L236.274 75.3279C236.397 75.1955 236.594 75.1629 236.753 75.2486L239.373 76.6602C239.6 76.783 239.883 76.6583 239.945 76.4073L242.83 64.8584C242.926 64.4734 243.466 64.4527 243.591 64.8292L246.247 72.8027C246.35 73.1137 246.765 73.1718 246.95 72.9012L249.79 68.7467C249.822 68.7008 249.863 68.662 249.91 68.6329L252.738 66.8909C252.96 66.7544 253.251 66.8647 253.326 67.1138L256.516 77.6734L259.772 91.9646C259.819 92.1674 260.014 92.3 260.219 92.2683L262.813 91.8689C263.025 91.8363 263.224 91.9778 263.263 92.1885L266.189 107.953C266.267 108.375 266.866 108.389 266.964 107.972L269.658 96.5687C269.738 96.2291 270.186 96.1512 270.376 96.4438L272.785 100.153C272.961 100.425 273.372 100.381 273.488 100.078L276.536 92.0987C276.544 92.0779 276.554 92.0578 276.565 92.0387L279.428 87.191C279.603 86.8936 280.049 86.9473 280.148 87.2779L283.034 96.8309C283.121 97.1178 283.482 97.2085 283.694 96.9965L286.515 94.1738C286.548 94.1407 286.586 94.1137 286.629 94.0941L289.566 92.7376C289.756 92.6499 289.981 92.7248 290.081 92.9088L292.969 98.2461C293.101 98.4899 293.436 98.5265 293.618 98.3169L296.555 94.9251C296.572 94.905 296.592 94.8867 296.613 94.8705L299.544 92.6134C299.74 92.4628 300.024 92.5257 300.138 92.7448L303.04 98.3301C303.154 98.5492 303.438 98.6121 303.634 98.4615L306.407 96.3265C306.524 96.2365 306.681 96.2189 306.815 96.2807L309.675 97.6016C309.831 97.6736 310.015 97.6372 310.132 97.5114L313.23 94.1717C313.26 94.14 313.284 94.1036 313.302 94.0641L316.614 86.6697L319.942 78.7276C319.949 78.7103 319.955 78.6924 319.96 78.6741L323.282 65.887C323.288 65.8622 323.297 65.838 323.308 65.8149L326.388 59.4136C326.506 59.1674 326.832 59.112 327.025 59.3053L329.891 62.1728C329.942 62.2241 329.978 62.2883 329.995 62.3587L333.308 75.8741L336.391 86.5576C336.488 86.8916 336.937 86.9486 337.114 86.6492L339.985 81.786'
              stroke='#C6C6C7'
              strokeWidth='1.17'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <path
            d='M195.505 83.8711H158.675C158.19 83.8711 157.797 84.6173 157.797 85.5397C157.797 86.4621 158.19 87.2083 158.675 87.2083H195.508C195.993 87.2083 196.386 86.4621 196.386 85.5397C196.386 84.6173 195.993 83.8711 195.508 83.8711H195.505Z'
            fill='#EBEBEB'
          />
          <path
            d='M187.338 90.9248H158.675C158.19 90.9248 157.797 91.671 157.797 92.5934C157.797 93.5158 158.19 94.262 158.675 94.262H187.338C187.824 94.262 188.216 93.5158 188.216 92.5934C188.216 91.671 187.824 90.9248 187.338 90.9248Z'
            fill='#EBEBEB'
          />
          <path
            d='M172.348 98.105H158.675C158.19 98.105 157.797 98.8512 157.797 99.7736C157.797 100.696 158.19 101.442 158.675 101.442H172.348C172.833 101.442 173.226 100.696 173.226 99.7736C173.226 98.8512 172.833 98.105 172.348 98.105Z'
            fill='#EBEBEB'
          />
          <path
            d='M177.527 111.687H161.876C159.613 111.687 157.777 113.518 157.777 115.777C157.777 118.036 159.613 119.867 161.876 119.867H177.527C179.791 119.867 181.626 118.036 181.626 115.777C181.626 113.518 179.791 111.687 177.527 111.687Z'
            fill='#424244'
          />
          <g clipPath='url(#clip4_19183_198407)'>
            <path
              d='M170.693 68.6265C174.115 68.6265 176.89 65.8521 176.89 62.4297C176.89 59.0073 174.115 56.2329 170.693 56.2329C167.27 56.2329 164.496 59.0073 164.496 62.4297C164.496 65.8521 167.27 68.6265 170.693 68.6265Z'
              fill='white'
            />
            <path
              d='M170.695 65.4217C170.304 65.4217 169.954 65.3484 169.645 65.2017C169.336 65.053 169.091 64.8496 168.909 64.5914C168.729 64.3332 168.633 64.0378 168.621 63.7053H169.677C169.697 63.9518 169.804 64.1532 169.997 64.3097C170.191 64.4642 170.424 64.5415 170.695 64.5415C170.909 64.5415 171.098 64.4926 171.265 64.3948C171.431 64.297 171.562 64.1611 171.658 63.987C171.754 63.8129 171.801 63.6143 171.799 63.3913C171.801 63.1644 171.753 62.963 171.655 62.7869C171.557 62.6109 171.423 62.473 171.253 62.3732C171.083 62.2715 170.887 62.2206 170.666 62.2206C170.486 62.2187 170.309 62.2519 170.135 62.3204C169.961 62.3889 169.823 62.4788 169.721 62.5903L168.738 62.429L169.052 59.3306H172.538V60.2401H169.953L169.78 61.8333H169.815C169.927 61.7023 170.084 61.5937 170.288 61.5077C170.491 61.4196 170.714 61.3756 170.957 61.3756C171.32 61.3756 171.645 61.4617 171.931 61.6338C172.216 61.804 172.441 62.0387 172.606 62.338C172.77 62.6373 172.852 62.9796 172.852 63.3649C172.852 63.762 172.76 64.1161 172.576 64.4271C172.394 64.7361 172.141 64.9797 171.816 65.1577C171.494 65.3337 171.12 65.4217 170.695 65.4217Z'
              fill='#76767A'
            />
            <path
              d='M170.705 54.2285C172.1 54.2285 173.23 52.8274 173.23 51.0991C173.23 49.3708 172.1 47.9697 170.705 47.9697C169.31 47.9697 168.18 49.3708 168.18 51.0991C168.18 52.8274 169.31 54.2285 170.705 54.2285Z'
              fill='#76767A'
            />
            <path
              d='M174.724 56.796L174.724 56.7943C174.877 56.3848 175 55.9648 175.092 55.5377C175.128 55.3693 175.297 55.3049 175.379 55.4564C175.645 55.9472 175.826 56.9778 175.817 57.6355C175.816 57.7059 175.841 57.7742 175.889 57.8262C176.812 58.836 177.416 60.0899 177.635 61.4307C177.676 61.6777 177.965 61.7389 178.052 61.5042C178.958 59.0679 180.077 52.226 174.028 50.1529C173.855 50.0937 173.678 50.2335 173.686 50.4159C173.786 52.7254 172.775 53.8428 171.919 54.3723C171.224 54.8018 170.347 54.8179 169.624 54.4387C168.687 53.9472 167.541 52.8555 167.659 50.4674C167.668 50.2925 167.508 50.1516 167.339 50.1962C163.201 51.2878 162.564 54.9985 162.599 56.8022C162.603 56.9904 162.806 57.0975 162.975 57.0127C163.865 56.5636 164.832 56.2833 165.826 56.1866C165.939 56.1756 166.033 56.0935 166.067 55.9845C166.092 55.9039 166.122 55.8248 166.156 55.7476C166.245 55.5453 166.509 55.636 166.52 55.8567C166.527 55.9984 166.652 56.0976 166.793 56.0833C167.097 56.0524 167.572 56.0142 168.144 55.9912C168.172 55.9901 168.2 55.9844 168.226 55.9746C169.288 55.5776 170.431 55.4435 171.557 55.584C172.693 55.7258 173.778 56.1433 174.716 56.8C174.719 56.8023 174.724 56.8 174.724 56.796Z'
              fill='#76767A'
            />
            <path
              d='M183.325 69.6788C184.023 68.4711 183.375 66.7914 181.878 65.927C180.382 65.0625 178.603 65.3408 177.906 66.5485C177.208 67.7561 177.856 69.4359 179.352 70.3003C180.849 71.1647 182.628 70.8864 183.325 69.6788Z'
              fill='#909093'
            />
            <path
              d='M177.153 67.5098C177.13 66.6951 177.554 65.9285 178.242 65.4932C179.136 64.9288 180.652 64.4857 182.658 65.7909C182.804 65.8864 183.006 65.8196 183.053 65.6509C184.198 61.5215 181.313 59.1292 179.73 58.2438C179.564 58.1509 179.367 58.2758 179.358 58.466C179.309 59.4628 179.073 60.4424 178.662 61.3532C178.616 61.4559 178.639 61.5764 178.715 61.6599C178.773 61.724 178.827 61.7911 178.877 61.8611C179.01 62.0459 178.808 62.2343 178.607 62.1279C178.477 62.0593 178.316 62.117 178.256 62.251C178.136 62.5189 177.944 62.9242 177.694 63.4047C177.68 63.4319 177.671 63.4615 177.667 63.4918C177.514 64.6311 177.085 65.716 176.416 66.6516C175.804 67.5084 175.008 68.2158 174.088 68.7231C173.939 68.8051 173.899 69.004 174.015 69.1277C174.197 69.321 174.386 69.5063 174.584 69.6832C174.713 69.799 174.683 69.9786 174.51 69.9721C174.023 69.9537 173.215 69.6766 172.63 69.3839C172.572 69.3549 172.505 69.3476 172.442 69.3635C171.154 69.6903 169.805 69.6464 168.55 69.2457C168.299 69.1655 168.083 69.4405 168.26 69.6352C170.2 71.7597 175.209 75.4193 179.753 71.466C179.891 71.3463 179.858 71.1235 179.697 71.0388C177.641 69.9613 177.181 68.5188 177.153 67.5098Z'
              fill='#909093'
            />
            <path
              d='M163.462 66.529C162.759 65.3206 160.983 65.0469 159.485 65.9093C157.988 66.7717 157.363 68.4552 158.065 69.6584C158.767 70.8616 160.544 71.1456 162.036 70.2781C163.529 69.4105 164.174 67.7374 163.462 66.529Z'
              fill='#58585B'
            />
            <path
              d='M163.653 62.558C163.653 62.4093 163.653 62.2669 163.661 62.1221C163.671 61.9452 163.518 61.7933 163.344 61.8297C163.027 61.8963 162.713 61.9805 162.405 62.0818C162.241 62.1358 162.099 62.0212 162.189 61.8737C162.492 61.3774 163.345 60.6683 163.921 60.3658C163.984 60.333 164.032 60.2788 164.056 60.2122C164.446 59.1091 165.106 58.1205 165.977 57.3372C166.151 57.1533 166.337 56.9813 166.534 56.8221C166.708 56.6804 166.65 56.4568 166.427 56.4837C164.173 56.755 156.996 59.1266 158.307 65.6673C158.343 65.846 158.553 65.9292 158.706 65.8309C160.654 64.5843 162.128 64.9017 163.014 65.3783C163.731 65.764 164.182 66.5132 164.22 67.3266C164.268 68.3903 163.903 69.9449 161.767 71.0521C161.611 71.1325 161.57 71.3408 161.693 71.4647C164.697 74.483 168.224 73.1882 169.772 72.2547C169.934 72.1568 169.924 71.9249 169.764 71.8227C168.922 71.2829 168.189 70.5886 167.603 69.7759C167.538 69.6851 167.423 69.6452 167.313 69.6685C167.234 69.6853 167.154 69.6981 167.074 69.7069C166.841 69.7324 166.772 69.4555 166.967 69.3255C167.091 69.2429 167.12 69.0725 167.034 68.9512C166.906 68.7712 166.732 68.5191 166.534 68.2241C166.517 68.1994 166.496 68.1777 166.473 68.1599C165.607 67.5131 164.902 66.6752 164.413 65.7112C163.917 64.7338 163.657 63.6539 163.653 62.558Z'
              fill='#58585B'
            />
          </g>
        </g>
        <rect
          x='143.335'
          y='31.1862'
          width='151.737'
          height='99.2037'
          rx='5.08365'
          stroke='#ECECEC'
          strokeWidth='0.8073'
        />
      </g>
      <g filter='url(#filter1_dddddd_19183_198407)'>
        <rect
          x='212.77'
          y='5.8501'
          width='107.858'
          height='70.3164'
          rx='4.68'
          fill='white'
          shapeRendering='crispEdges'
        />
        <rect
          x='212.366'
          y='5.44645'
          width='108.665'
          height='71.1236'
          rx='5.08365'
          stroke='#ECECEC'
          strokeWidth='0.8073'
          shapeRendering='crispEdges'
        />
        <path
          d='M261.885 41.1914H223.067C222.555 41.1914 222.141 41.7436 222.141 42.426C222.141 43.1085 222.555 43.6607 223.067 43.6607H261.888C262.4 43.6607 262.814 43.1085 262.814 42.426C262.814 41.7436 262.4 41.1914 261.888 41.1914H261.885Z'
          fill='#EBEBEB'
        />
        <path
          d='M253.277 46.4102H223.067C222.555 46.4102 222.141 46.9623 222.141 47.6448C222.141 48.3273 222.555 48.8794 223.067 48.8794H253.277C253.789 48.8794 254.203 48.3273 254.203 47.6448C254.203 46.9623 253.789 46.4102 253.277 46.4102Z'
          fill='#EBEBEB'
        />
        <path
          d='M237.477 51.7231H223.067C222.555 51.7231 222.141 52.2753 222.141 52.9578C222.141 53.6403 222.555 54.1924 223.067 54.1924H237.477C237.989 54.1924 238.403 53.6403 238.403 52.9578C238.403 52.2753 237.989 51.7231 237.477 51.7231Z'
          fill='#EBEBEB'
        />
        <rect x='222.125' y='36.27' width='20.198' height='2.46648' rx='1.23324' fill='#EBEBEB' />
        <path
          d='M236.742 63.5039H225.162C223.487 63.5039 222.129 64.8589 222.129 66.5304C222.129 68.2019 223.487 69.5569 225.162 69.5569H236.742C238.417 69.5569 239.775 68.2019 239.775 66.5304C239.775 64.8589 238.417 63.5039 236.742 63.5039Z'
          fill='#424244'
        />
        <path d='M222.125 12.8696H243.185V33.9296H222.125V12.8696Z' fill='white' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M235.957 21.0963C235.957 22.0656 235.171 22.8513 234.202 22.8513C233.233 22.8513 232.447 22.0656 232.447 21.0963C232.447 20.127 233.233 19.3413 234.202 19.3413C235.171 19.3413 235.957 20.127 235.957 21.0963ZM231.606 19.4217H224.586L224.586 22.9317H228.096V28.0798H231.606V19.4217ZM237.76 19.4217H241.785L238.158 28.0798H234.121L237.76 19.4217Z'
          fill='black'
        />
      </g>
      <rect x='288.816' y='51.5869' width='24.4008' height='2.52422' rx='0.841407' fill='#EBEBEB' />
      <rect x='297.008' y='55.7944' width='15.9867' height='2.52422' rx='0.841407' fill='#EBEBEB' />
      <rect x='270.098' y='40.2285' width='5.04844' height='4.62774' rx='0.841407' fill='#EBEBEB' />
      <rect x='277.672' y='27.6069' width='5.04844' height='17.2488' rx='0.841407' fill='#EBEBEB' />
      <rect x='285.238' y='23.3999' width='5.04844' height='21.4559' rx='0.841407' fill='#EBEBEB' />
      <rect x='292.82' y='36.0205' width='5.04844' height='8.83477' rx='0.841407' fill='#EBEBEB' />
      <rect x='300.387' y='31.814' width='5.04844' height='13.0418' rx='0.841407' fill='#EBEBEB' />
      <rect x='307.961' y='23.3999' width='5.04844' height='21.4559' rx='0.841407' fill='#EBEBEB' />
      <defs>
        <filter
          id='filter0_dddd_19183_198407'
          x='135.133'
          y='30.7827'
          width='168.141'
          height='123.401'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='7.79692'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_19183_198407'
          />
          <feOffset dy='15.5938' />
          <feGaussianBlur stdDeviation='7.79692' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1.46192'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_19183_198407'
          />
          <feOffset dy='2.92384' />
          <feGaussianBlur stdDeviation='1.46192' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_19183_198407'
            result='effect2_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.730961'
            operator='erode'
            in='SourceAlpha'
            result='effect3_dropShadow_19183_198407'
          />
          <feOffset dy='1.46192' />
          <feGaussianBlur stdDeviation='0.730961' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_19183_198407'
            result='effect3_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.243654'
            operator='erode'
            in='SourceAlpha'
            result='effect4_dropShadow_19183_198407'
          />
          <feOffset dy='0.487307' />
          <feGaussianBlur stdDeviation='0.243654' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect3_dropShadow_19183_198407'
            result='effect4_dropShadow_19183_198407'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect4_dropShadow_19183_198407'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_dddddd_19183_198407'
          x='196.367'
          y='5.04297'
          width='140.66'
          height='118.712'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='15.5938'
            operator='erode'
            in='SourceAlpha'
            result='effect1_dropShadow_19183_198407'
          />
          <feOffset dy='31.1877' />
          <feGaussianBlur stdDeviation='15.5938' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='7.79692'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_19183_198407'
          />
          <feOffset dy='15.5938' />
          <feGaussianBlur stdDeviation='7.79692' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_19183_198407'
            result='effect2_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='2.92384'
            operator='erode'
            in='SourceAlpha'
            result='effect3_dropShadow_19183_198407'
          />
          <feOffset dy='5.84769' />
          <feGaussianBlur stdDeviation='2.92384' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_19183_198407'
            result='effect3_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1.46192'
            operator='erode'
            in='SourceAlpha'
            result='effect4_dropShadow_19183_198407'
          />
          <feOffset dy='2.92384' />
          <feGaussianBlur stdDeviation='1.46192' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect3_dropShadow_19183_198407'
            result='effect4_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.730961'
            operator='erode'
            in='SourceAlpha'
            result='effect5_dropShadow_19183_198407'
          />
          <feOffset dy='1.46192' />
          <feGaussianBlur stdDeviation='0.730961' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect4_dropShadow_19183_198407'
            result='effect5_dropShadow_19183_198407'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='0.243654'
            operator='erode'
            in='SourceAlpha'
            result='effect6_dropShadow_19183_198407'
          />
          <feOffset dy='0.487307' />
          <feGaussianBlur stdDeviation='0.243654' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0' />
          <feBlend
            mode='normal'
            in2='effect5_dropShadow_19183_198407'
            result='effect6_dropShadow_19183_198407'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect6_dropShadow_19183_198407'
            result='shape'
          />
        </filter>
        <clipPath id='clip0_19183_198407'>
          <rect width='211.77' height='138.06' fill='white' transform='translate(26.7383 80.73)' />
        </clipPath>
        <clipPath id='clip1_19183_198407'>
          <rect
            width='99.45'
            height='93.6'
            fill='white'
            transform='matrix(-1 0 0 1 225.641 102.96)'
          />
        </clipPath>
        <clipPath id='clip2_19183_198407'>
          <rect x='143.738' y='31.5898' width='150.93' height='98.3964' rx='4.68' fill='white' />
        </clipPath>
        <clipPath id='clip3_19183_198407'>
          <rect
            width='120.802'
            height='69.03'
            fill='white'
            transform='translate(219.789 40.9497)'
          />
        </clipPath>
        <clipPath id='clip4_19183_198407'>
          <rect width='25.82' height='25.82' fill='white' transform='translate(157.777 47.9697)' />
        </clipPath>
      </defs>
    </svg>
  )
}
